<template>
  <div v-show="pVisible" class="bs3-margin-bottom">
    <textarea rows="5" v-model="options" class="form-control" :placeholder="pDictionary['dictionary.tag.value.add.placeholder']"></textarea>
    <div class="bs3-margin-top text-right">
      <button class="btn btn-default btn-sm" :disabled="addButtonDisabled" @click.prevent="addTagOptions"><i class="fa-light fa-plus"></i> {{'dictionary.actions.add' | i18nText(pDictionary)}}</button>
      <button class="btn btn-link btn-sm" @click.prevent="cancelAddTagOptions">{{'dictionary.actions.cancel' | i18nText(pDictionary)}}</button>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import stringhelpers from "@/helpers/string-helpers"

export default {
  name: "TagSaveFormAddOptions",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pVisible: Boolean
  },
  data: function () {
    return {
      options: ''
    }
  },
  methods: {
    addTagOptions: function() {
      let options = stringhelpers.getLines(this.options);
      this.$emit('add-options', options);
      this.options = '';
    },
    cancelAddTagOptions: function() {
      this.$emit('cancel-add-options');
      this.options = '';
    }
  },
  computed: {
    addButtonDisabled: function(){
      return this.options === '';
    }
  }
}
</script>

<style scoped>

</style>